import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { Moment } from "moment";
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import UploadFile from "../../../../../components/UploadFile";

export default function DialogImportarArquivos({
    open,
    handleClose,
}: DialogImportarArquivosProps) {

    const queryClient = useQueryClient();

    const { control, watch, setValue, handleSubmit, formState } = useForm({
        defaultValues: {
            modalidade: 'Rede EDI',
            arquivos: []
        }
    });

    //Querys e Mutations
    const { mutate, isLoading } = useMutation({
        mutationKey: 'importar-arquivo-bancario',
        mutationFn: (inputs: any) => axiosClient.post("/financeiro/integracao-bancaria/importar-arquivo",
            inputs,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ),
        onSuccess: () => {
            queryClient.invalidateQueries("pesquisar-integracoes-bancarias")
            enqueueSnackbar(`Importação realizada com sucesso!`, { variant: 'success' });
            handleClose();
        },
        onError: () => {
            enqueueSnackbar('Erro ao importar arquivo', { variant: 'error' });
        }
    })

    const onSubmit: SubmitHandler<any> = (data) => {
        const formData = new FormData();

        formData.append('modalidade', data.modalidade);

        data.arquivos.forEach((file: File, index: number) => {
            formData.append(`arquivos[${index}]`, file);
        });

        mutate(formData);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
            >
                <DialogTitle>Importar arquivo</DialogTitle>
                <DialogContent>

                    <Controller
                        rules={{ required: true }}
                        control={control}
                        name="modalidade"
                        render={({ field }) => (
                            <FormControl>
                                <FormLabel>Modalidade</FormLabel>
                                <RadioGroup
                                    {...field}
                                    row
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        field.onChange((event.target as HTMLInputElement).value);
                                    }}
                                >
                                    <FormControlLabel value="Rede EDI" control={<Radio />} label="Rede EDI" />
                                    <FormControlLabel value="Safra EDI" control={<Radio />} label="Safra EDI" />
                                    <FormControlLabel value="CNAB240" control={<Radio />} label="CNAB240" />
                                    <FormControlLabel value="Sipag" disabled control={<Radio />} label="Sipag EDI" />
                                </RadioGroup>
                            </FormControl>
                        )} />

                    <Controller
                        control={control}
                        name="arquivos"
                        render={() => (
                            <Box mt={2}>
                                <UploadFile
                                    values={watch('arquivos')}
                                    multiple={true}
                                    onChangeValues={(files: any) => setValue('arquivos', files)}
                                />
                            </Box>
                        )} />

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="outlined">
                        Cancelar
                    </Button>
                    <Button
                        disabled={isLoading || !formState.isValid}
                        onClick={handleSubmit(onSubmit)}
                        variant="contained">
                        {isLoading && (
                            <CircularProgress size={14} style={{ marginRight: 12 }} />
                        )}{" "}
                        Importar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
interface DialogImportarArquivosProps {
    open: boolean;
    diaSelecionado: Moment
    handleClose: () => void;
}